// Runs before any other module of the app: imports are evaluated in order, and the router (src/app/Routes.tsx) copies
// the address once, when its module loads. The address is cleaned of ?email= here, before that, or the steps carry it
// on (SigninPage keeps the query when it moves between steps).
import { moveEmailFromAddressToDraft, removeStoredSignupPassword } from '@Shared/utils/useLocalStorage';
import { startAnalytics } from '@Shared/utils/posthog';

removeStoredSignupPassword();
moveEmailFromAddressToDraft();
startAnalytics();
